import VersaoTabelaIbptService from "@/services/VersaoTabelaIbptService";

export const versaoTabelaIbpt = {
  namespaced: true,
  state: {
    versaoTabelaIbpt: {},
  },
  actions: {
    getVersaoTabelaIbpt({ commit }, payload) {
      return VersaoTabelaIbptService.GetVersaoTabelaIbpt(payload).then(
        (versaoTabelaIbpt) => {
          return Promise.resolve(versaoTabelaIbpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVersaoTabelaIbpt({ commit }, payload) {
      return VersaoTabelaIbptService.PostVersaoTabelaIbpt(payload).then(
        (versaoTabelaIbpt) => {
          return Promise.resolve(versaoTabelaIbpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVersaoTabelaIbpt({ commit }, payload) {
      return VersaoTabelaIbptService.PutVersaoTabelaIbpt(payload).then(
        (versaoTabelaIbpt) => {
          return Promise.resolve(versaoTabelaIbpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVersaoTabelaIbpt({ commit }, payload) {
      return VersaoTabelaIbptService.DeleteVersaoTabelaIbpt(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVersaoTabelaIbptOData({ commit }, payload) {
      return VersaoTabelaIbptService.GetVersaoTabelaIbptOData(payload).then(
        (versaoTabelaIbpt) => {
          return Promise.resolve(versaoTabelaIbpt);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default versaoTabelaIbpt;
